var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DataGridColumn',_vm._g(_vm._b({scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(_vm.isRenderColumn)?[_vm._t("default",null,null,scope)]:_c('span',{domProps:{"innerHTML":_vm._s(_vm.getRenderCellValue(scope.row, _vm.tableColumn.prop, scope.isHidden))}})]}}],null,true)},'DataGridColumn',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }